<div
  class="bg-scores bg-top w-full h-238 rounded-10 max-sm:rounded-5 max-sm:h-81 grid grid-cols-3 justify-evenly text-white items-center text-center"
>
  <!-- Home Team Container -->
  <div
    class="flex flex-col items-center gap-2 cursor-pointer font-roboto-800 text-20 hover:underline max-sm:text-10 max-sm:gap-1"
    (click)="openTeam(infoMatch.homeTeam)"
  >
    <!-- Home Team Logo -->
    <div
      class="feature-logo"
    >
      <img
        alt="homeTeam-logo"
        [src]="
          infoMatch.homeTeam?.logo
            ? infoMatch.homeTeam.logo
            : urlImg + 'default.png'
        "
      />
    </div>
    <!-- Home Team Name -->
    {{
      infoMatch.homeTeam?.name || infoMatch.homeTeam?.player1?.knownName || "NA"
        | uppercase
    }}

    <!--  FOR FAVORITE -->
    <!--
    [nzTheme]="infoMatch.favoriteHome ? 'fill' : 'outline'"
    (click)="$event.stopPropagation(); markTeamFavorite(infoMatch.homeTeam, 'H', infoMatch)">
    -->

    <!-- FOR WINNER TEAM -->
    <!--
    [ngClass]="{'winner-team': infoMatch.statusId === 100 && infoMatch.homeScores.scoreFinal > infoMatch.awayScores.scoreFinal}"
    -->
  </div>

  <!-- Match Score and Status -->
  <div class="text-center">
    <div
      class="font-pilat-900 text-32 max-sm:text-14"
      [ngClass]="{ 'efect-inlive': infoMatch.statusId === 2 }"
    >
      {{
        infoMatch.statusId === 100 || infoMatch.statusId === 2
          ? infoMatch.homeScores?.scoreFinal ||
            infoMatch.homeTeam?.scores?.current
          : 0
      }}
      <span class="mx-2">-</span
      >{{
        infoMatch.statusId === 100 || infoMatch.statusId === 2
          ? infoMatch.awayScores?.scoreFinal ||
            infoMatch.awayTeam?.scores?.current
          : 0
      }}
    </div>
    <div class="font-roboto-700 text-20 max-sm:text-10 mt-1">
      {{ infoMatch.score.status.text | uppercase }}
      <!-- {{ infoMatch.score.matchTimeCurrent }} -->

      <!-- FOR COUNT -->
      <!--
      <span
        class="status-text"
        *ngIf="
          infoMatch.score.status.code == 2 ||
          infoMatch.score.status.code == 4 ||
          infoMatch.score.status.code == 5
        "
      >
        {{ this.countMatch }}
      </span>
      -->
    </div>
    <div
      class="font-roboto-500 text-17 flex gap-1 justify-center items-center mt-4 max-sm:text-8 max-sm:mt-1"
    >
      <img
        alt="calendar"
        class="max-sm:w-[10px]"
        [src]="urlIcon + 'calendar-white.svg'"
      />
      {{ infoMatch.score?.matchDate }}
      {{ infoMatch.statusId === 2 ? infoMatch.score?.matchTime : "" }}
    </div>
  </div>

  <!-- Away Team Container -->
  <div
    class="flex flex-col items-center gap-2 cursor-pointer font-roboto-800 text-20 hover:underline max-sm:text-10 max-sm:gap-1 text-center"
    (click)="openTeam(infoMatch.awayTeam)"
  >
    <!-- Away Team Logo -->
    <div
      class="feature-logo"
    >
      <img
        alt="awayTeam-logo"
        [src]="
          infoMatch.awayTeam?.logo
            ? infoMatch.awayTeam.logo
            : urlImg + 'default.png'
        "
      />
    </div>
    <!-- Away Team Name -->
    {{
      infoMatch.awayTeam?.name || infoMatch.awayTeam?.player1?.knownName || "NA"
        | uppercase
    }}

    <!--  FOR FAVORITE -->
    <!--
    [nzTheme]="infoMatch.favoriteAway ? 'fill' : 'outline'"
    (click)="$event.stopPropagation();markTeamFavorite(infoMatch.awayTeam, 'A', infoMatch)"
    -->

    <!-- FOR WINNER TEAM -->
    <!--
    [ngClass]="{'winner-team': infoMatch.statusId === 100 &&
    infoMatch.awayScores.scoreFinal > infoMatch.homeScores.scoreFinal}"
    -->
  </div>
</div>
